































import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import BaseServiceMixin from "../mixins/base.service.mixin";
import DepartmentModel from "../models/DepartmentModel";
import DepartmentService from "../services/department.service";
import eventBus from "../common/bus";
import { Role } from "@/common/enum";
import Shared from "../common/shared";

@Component({
  components: {
    ValidationObserver,
  },
})
export default class UpsertDepartment extends Mixins(BaseServiceMixin) {
  @Prop({ default: () => new DepartmentModel() })
  public department!: DepartmentModel;

  private departmentService!: DepartmentService;
  private role = Role;
  private localDepartment: DepartmentModel = new DepartmentModel();

  public created() {
    this.departmentService = new DepartmentService(this.axiosInstance);
  }

  private mounted() {
    this.updateInternalStorage();
  }

  @Watch("department", { deep: true })
  private updateInternalStorage() {
    this.localDepartment = Object.assign(new DepartmentModel(), this.department);
  }

  private async saveDepartment() {
    eventBus.$emit("loading", true);
    try {
      let res: DepartmentModel = new DepartmentModel();
      if (this.localDepartment.id) {
        res = await this.departmentService.updateDepartment(this.localDepartment);
      } else {
        res = await this.departmentService.addDepartment(this.localDepartment);
      }
      this.$emit("onSave", res);
    } catch (error) {
      if (error.name === Shared.conflict) {
        Shared.showToastMessage(error.message || Shared.messages.DEPARTMENT_CONFLICT, "is-danger");
      }
    } finally {
      eventBus.$emit("loading", false);
    }
  }
}
